import React, { useState } from "react";
import ColorPicker from "../../../components/ColorPicker";

const ButtonTab = ({updateBackToTopTabData,backToTopTabData }) => {
    const [textTitle, setTextTitle] = useState(backToTopTabData.text_title);
    const [buttonColor, setButtonColor] = useState(backToTopTabData.button_color);
    const [icionTextColor, setIcionTextColor] = useState(backToTopTabData.icion_text_color);
    const [borderColor, setBorderColor] = useState(backToTopTabData.border_color);
    const [activeSizeType, setActiveSizeType] = useState(backToTopTabData.size_type);
    const [activeShapeType, setActiveShapeType] = useState(backToTopTabData.shape_type);

    // Handlers text Title Change
    const handleTextTitleChange = (value) => {
        setTextTitle(value);
        updateBackToTopTabData("text_title", value);
    };

    // Handlers Button Color Change
    const handleButtonColorChange = (color) => {
        setButtonColor(color.hex);
        updateBackToTopTabData("button_color", color.hex);
    };

    // Handlers icion and text Color Change
    const handleIcionTextColorChange = (color) => {
        setIcionTextColor(color.hex);
        updateBackToTopTabData("icion_text_color", color.hex);
    };

    // Handlers Border Color Change
    const handleBorderColorChange = (color) => {
        setBorderColor(color.hex);
        updateBackToTopTabData("border_color", color.hex);
    };

    // Handle Size Type change
    const handleActiveSizeTypeChange = (event) => {
        setActiveSizeType(event.target.value);
        updateBackToTopTabData("size_type", event.target.value);
    };

    // Handle Shape Type change
    const handleActiveShapeTypeChange = (event) => {
        setActiveShapeType(event.target.value);
        updateBackToTopTabData("shape_type", event.target.value);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Button</span>
            <div className="side-baar-box-header">
                <div className="box-header-row bubble-text">
                    <span>Text (Optional)</span>
                    <input name="text_title" type="text" value={textTitle} onChange={(e) => handleTextTitleChange(e.target.value)} />
                </div>
            </div>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Button Color</span>
                    <div className="color-pikr-box">
                        <ColorPicker color={buttonColor} setColor={setButtonColor} onChangeComplete={handleButtonColorChange}/>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Icon & Text Color</span>
                    <div className="color-pikr-box">
                        <ColorPicker color={icionTextColor} setColor={setIcionTextColor}  onChangeComplete={handleIcionTextColorChange}/>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Border Color</span>
                    <div className="color-pikr-box">
                        <ColorPicker color={borderColor} setColor={setBorderColor} onChangeComplete={handleBorderColorChange}/>
                    </div>
                </div>
            </div>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <p>Size</p>
                    <div className="left-cnater-right-button">
                        <label className="card-radio-btn">
                            <input type="radio" name="size_type" className="card-input-element d-none" value="small" onChange={handleActiveSizeTypeChange} checked={activeSizeType === "small"} />
                            <div className="card card-body">
                                <div className="content_sub">Small</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="size_type" className="card-input-element d-none" value="medium" onChange={handleActiveSizeTypeChange} checked={activeSizeType === "medium"} />
                            <div className="card card-body">
                                <div className="content_sub">Medium</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="size_type" className="card-input-element d-none" value="large" onChange={handleActiveSizeTypeChange} checked={activeSizeType === "large"} />
                            <div className="card card-body">
                                <div className="content_sub">Large</div>
                            </div>
                        </label>
                    </div>
                </div>
                <div className="box-header-row">
                    <p>Shape</p>
                    <div className="left-cnater-right-button">
                        <label className="card-radio-btn">
                            <input type="radio" name="shape_type" className="card-input-element d-none" value="normal-shape" onChange={handleActiveShapeTypeChange} checked={activeShapeType === "normal-shape"} />
                            <div className="card card-body">
                                <div className="content_sub">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path fill="#fab300" fill-rule="evenodd" d="M15.833 4.167V17.5h-1.568V5.735H2.5V4.167z"></path>
                                    </svg>
                                </div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="shape_type" className="card-input-element d-none" value="medium-shape" onChange={handleActiveShapeTypeChange} checked={activeShapeType === "medium-shape"} />
                            <div className="card card-body">
                                <div className="content_sub">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#fab300" fill-rule="evenodd" d="M9.82 4.167a6.013 6.013 0 0 1 6.01 5.839l.003.174v7.32h-1.568v-7.32a4.445 4.445 0 0 0-4.289-4.442l-.156-.003H2.5V4.167h7.32Z"></path></svg>
                                </div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="shape_type" className="card-input-element d-none" value="large-shape" onChange={handleActiveShapeTypeChange} checked={activeShapeType === "large-shape"} />
                            <div className="card card-body">
                                <div className="content_sub">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#fab300" fill-rule="evenodd" d="M3.284 4.167c6.856 0 12.428 5.498 12.547 12.326l.002.223v.784h-1.568v-.784c0-5.994-4.803-10.866-10.77-10.979l-.21-.002H2.5V4.167h.784Z"></path></svg>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ButtonTab; 